module.exports = __webpack_public_path__ + "static/media/3dspeech_green.5ef2dc17.png";